import aboutImg from '../svgs/about.svg';
import helpImg from '../svgs/help.svg';
import legalImg from '../svgs/legal.svg';
import twitterImg from '../svgs/twitter.svg';
import telegramImg from '../svgs/telegram.svg';
import youtubeImg from '../svgs/youtube.svg';
import applyImg from '../svgs/apply_champion.svg';
import loginImg from '../svgs/champion_login.svg';
import signupImg from '../svgs/champion_signup.svg';
import logoutImg from '../svgs/logout.svg';
import profileImg from '../svgs/profile.svg';

export const VERIFICATION_PROP = 'is_verified_champion';
export const CHAMPION_VERIFIED_STATES = {
  IN_PROGRESS: 'IN_PROGRESS',
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
  REJECTED: 'REJECTED',
};

export const COMMON_SELECT_VALUES = [
  { label: 'header.about', icon: aboutImg, href: 'https://www.hord.app/about' },
  { label: 'header.help', icon: helpImg, onClick: () => window.Intercom('show') },
  { label: 'header.twitter', icon: twitterImg, href: 'https://twitter.com/HordApp' },
  { label: 'header.telegram', icon: telegramImg, href: 'https://t.me/hord_app' },
  { label: 'header.youtube', icon: youtubeImg, href: 'https://www.youtube.com/channel/UCOhzE0AKC1ZFElFqIxbFAmw' },
  { label: 'header.terms', icon: legalImg, href: 'https://www.hord.app/terms-of-services' },
];

export const NOT_CONNECTED_CHAMPION_SELECT_VALUES = [
  ...COMMON_SELECT_VALUES,
  { value: 'apply', label: 'header.apply_as_champion', icon: applyImg },
  { value: 'login', label: 'champion.login', icon: loginImg },
  { value: 'signup', label: 'champion.sign_up', icon: signupImg },
];

export const CONNECTED_CHAMPION_SELECT_VALUES = [
  ...COMMON_SELECT_VALUES,
  { value: 'profile', label: 'champion.profile', icon: profileImg },
  { value: 'logout', label: 'champion.logout', icon: logoutImg },
  // {
  //   value: 'apply',
  //   label: 'header.apply_as_champion',
  //   hide: ({ isChamp }) => isChamp,
  //   action: () => window.open('https://dcentralab.typeform.com/to/Jp5jmOcy', '_blank').focus(),
  // },
];

export const POOL_LEGEND_COLORS = {
  'Deposit Funds': 'var(--champion-legend-deposit)',
  Creating: 'var(--champion-legend-creating)',
  'Ticket Sale': 'var(--champion-legend-ticket-sale)',
  Subscription: 'var(--champion-legend-subscription)',
  'Private Subscription': 'var(--champion-legend-private-subscription)',
  'Public Subscription': 'var(--champion-legend-subscription)',
  Deploying: 'var(--champion-legend-deploying)',
  'Subscription Failed': 'var(--champion-legend-subscribtion-failed)',
  Live: 'var(--champion-legend-live)',
  Updating: 'var(--champion-legend-updating)',
  Ending: 'var(--champion-legend-ending)',
  Ended: 'var(--champion-legend-ended)',
  'State Transition Pending': 'var(--champion-legend-updating)',
  'State Transition Failed': 'var(--champion-legend-deploying)',
};
